export default {
  benefit: null,
  benefitDistribution: null,
  generatedBenefitCode: null,
  benefitMovementHistory: [],
  metrics: [],
}
